import React, { useState } from 'react';
import { MAX_SCORE, scoreFromDigits, stepScore, typedDigits } from '../../utils/predictionCompose';
import { TeamMark } from './gameBits';

// One team's score: minus, a typeable number, plus. Typing strips anything but digits and
// leading zeros; the field may sit empty while focused and settles to the score on blur.
function ScoreStepper({ value, onChange, label }) {
  const [draft, setDraft] = useState(null);
  const shown = draft == null ? String(value) : draft;
  return (
    <span className="games-stepper">
      <button type="button" onClick={() => onChange(stepScore(value, -1))} disabled={value <= 0} aria-label="Decrease">
        −
      </button>
      <input
        className="games-score-input"
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        maxLength={3}
        autoComplete="off"
        aria-label={`${label} score`}
        value={shown}
        // Sized per digit in pixels with slack: a ch unit measures a "0", and wider digits in
        // this condensed face would otherwise run into the edge of the box.
        style={{ width: `${Math.max(1, shown.length || 1) * 34 + 12}px` }}
        onFocus={(event) => {
          if (event.target.value === '0') setDraft('');
          else event.target.select();
        }}
        onChange={(event) => {
          const digits = typedDigits(event.target.value);
          setDraft(digits);
          onChange(scoreFromDigits(digits));
        }}
        onBlur={() => setDraft(null)}
      />
      <button type="button" onClick={() => onChange(stepScore(value, 1))} disabled={value >= MAX_SCORE} aria-label="Increase">
        +
      </button>
    </span>
  );
}

export default function ComposeMatch({ event, scores, onChange }) {
  return (
    <div className="games-compose">
      <span className="games-compose-side">
        <TeamMark name={event.home_name} logoUrl={event.home_logo} />
        <ScoreStepper label={event.home_name || 'Home'} value={scores.home} onChange={(home) => onChange({ ...scores, home })} />
      </span>
      <span className="games-compose-rule" aria-hidden="true" />
      <span className="games-compose-side">
        <TeamMark name={event.opponent_name} logoUrl={event.opponent_logo} />
        <ScoreStepper label={event.opponent_name || 'Away'} value={scores.away} onChange={(away) => onChange({ ...scores, away })} />
      </span>
    </div>
  );
}

export function ReadonlyMatch({ event, scores }) {
  return (
    <div className="games-compose is-readonly">
      <span className="games-compose-side">
        <TeamMark name={event.home_name} logoUrl={event.home_logo} />
        <strong className="games-readonly-score">{scores.home}</strong>
      </span>
      <span className="games-compose-rule" aria-hidden="true" />
      <span className="games-compose-side">
        <TeamMark name={event.opponent_name} logoUrl={event.opponent_logo} />
        <strong className="games-readonly-score">{scores.away}</strong>
      </span>
    </div>
  );
}
